import { Files } from '../../lib/constants/files'
import { Hobby } from '../../lib/types/models/hobby/hobby'
import { HobbyInput } from '../../lib/types/models/hobby/hobby-input'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function createHobby(data: HobbyInput) {
  // If picto is provided, upload it
  if (data.picto) {
    const uploadedFile = await uploadFile(Files.HOBBY_PICTO, data.picto)
    if (uploadedFile) data.picto = uploadedFile
    else throw new Error('File not uploaded')
  }

  return restApiClient.url(constructApiUrl(API.hobbies.create.url, null)).post<Hobby>(data)
}
